import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";
import * as _ from "lodash";

@Directive({
  selector: "[appAppAccess]",
})
export class AppAccessDirective {
  @Input() appAccess: string = "";
  user: any = {};
  constructor(
    private el: ElementRef,
    private authService: AuthService,
  ) {
    this.user = this.authService.getCurrentUser();
  }

  ngOnInit() {
    // debugger

    this.el.nativeElement.style.display = "none";
    let hasAcces = true;
    if (
      this.user &&
      this.user.fonctionnalites &&
      this.user.fonctionnalites.length
    )
      // hasAcces = _.find(this.user.fonctionnalites, (o) => { return o.code?.trim().toLowerCase() == this.appAccess?.trim()?.toLowerCase() });
      hasAcces = _.find(this.user.fonctionnalites, (o) => {
        return o.code == this.appAccess;
      });

    // if (hasAcces) {
    //   this.el.nativeElement.style.display = 'block';
    // }else {
    //   this.el.nativeElement.style.display = 'none';
    // }
    this.el.nativeElement.style.display = "block";
  }
}
